export const FLAG_GETTING_REGISTERED_BUS_FLEETS = 'FLAG_GETTING_REGISTERED_BUS_FLEETS';
export const GET_REGISTERED_BUS_FLEETS = 'GET_REGISTERED_BUS_FLEETS';
export const CLEAR_REGISTERED_BUS_FLEETS = 'CLEAR_REGISTERED_BUS_FLEETS';

export const FLAG_BUS_RETENTION_SCHEDULE_ACTIVITY = 'FLAG_BUS_RETENTION_SCHEDULE_ACTIVITY';

export const GET_CURRENT_STATUS_REGISTERED_BUS_FLEETS = 'GET_CURRENT_STATUS_REGISTERED_BUS_FLEETS';
export const CLEAR_CURRENT_STATUS_REGISTERED_BUS_FLEETS = 'CLEAR_CURRENT_STATUS_REGISTERED_BUS_FLEETS';
export const FLAG_GETTING_CURRENT_STATUS_REGISTERED_BUS_FLEETS = 'FLAG_GETTING_CURRENT_STATUS_REGISTERED_BUS_FLEETS';
